import { useAuth } from '../../features/auth/AuthContext.js';
import { toggleMobileSidebar } from '../../store/ui.store.js';

export default function Header() {
  const { user, signOut } = useAuth();

  return (
    <header className="app-header">
      <button
        className="app-header__hamburger"
        onClick={toggleMobileSidebar}
        aria-label="Toggle navigation menu"
      >
        ☰
      </button>
      <div className="app-header__brand">
        <span className="app-header__logo">Ferngate</span>
        <span className="app-header__tagline">Plan. Track. Improve.</span>
      </div>
      <div className="app-header__user">
        <span className="app-header__email">{user?.username}</span>
        <button className="btn btn--ghost btn--sm" onClick={signOut}>
          Sign out
        </button>
      </div>
    </header>
  );
}
